var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2314_4658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1075 7.8828L20.9155 1.0748C21.8685 0.121796 23.4495 0.180795 24.3245 1.2508C25.0855 2.1808 24.9225 3.5678 24.0725 4.4178L17.3575 11.1328C16.5445 11.9458 15.4425 12.4018 14.2935 12.4018H13.3385C13.0625 12.4018 12.8385 12.1778 12.8385 11.9018V10.9468C12.8385 9.7978 13.2955 8.6948 14.1075 7.8828ZM23.3125 8.9018C22.4845 8.9018 21.8125 9.5728 21.8125 10.4018V14.9018C21.8125 16.2808 20.6915 17.4018 19.3125 17.4018H17.6005C17.2515 17.4018 16.9135 17.5238 16.6445 17.7458L12.8165 20.9128L9.0665 17.7548C8.7965 17.5268 8.4545 17.4018 8.1005 17.4018H6.3125C4.9335 17.4018 3.8125 16.2808 3.8125 14.9018V5.9018C3.8125 4.5238 4.9335 3.4018 6.3125 3.4018H15.3125C16.1405 3.4018 16.8125 2.7308 16.8125 1.9018C16.8125 1.0728 16.1405 0.401796 15.3125 0.401796H6.3125C3.2805 0.401796 0.8125 2.8688 0.8125 5.9018V14.9018C0.8125 17.9338 3.2805 20.4018 6.3125 20.4018H7.5525L11.1515 23.4318C11.6305 23.8578 12.2315 24.0678 12.8265 24.0678C13.4085 24.0678 13.9845 23.8658 14.4325 23.4668L18.1405 20.4018H19.3125C22.3445 20.4018 24.8125 17.9338 24.8125 14.9018V10.4018C24.8125 9.5728 24.1405 8.9018 23.3125 8.9018Z",
    fill: "#0058B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2314_4658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.8125 0.401611)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.218e50e809cddd21a9a3af88f9145610.svg";
export { ForwardRef as ReactComponent };